<template>
  <ValidationObserver v-slot="{ handleSubmit }">
    <form @submit.prevent="handleSubmit(atualizar)">
      <div class="card shadow-22">
        <h1>Atualizar cadastro</h1>
        <div class="p-fluid formgrid grid">
          <transition-group name="p-messages" tag="div" class="col-12 md:col-4">
            <Message
              v-for="msg of messages"
              :severity="msg.severity"
              :key="msg.content"
              >{{ msg.content }}</Message
            >
          </transition-group>

          <div class="field col-12">
            <label for="nome" class="required">Nome Completo</label>
            <ValidationProvider
              name="Nome"
              rules="required|min:10"
              v-slot="{ errors, classes }"
              mode="lazy"
            >
              <InputText
                id="nome"
                v-model.lazy="usuario.nome"
                type="text"
                :class="classes"
              />
              <InlineMessage v-if="errors[0]">{{ errors[0] }}</InlineMessage>
            </ValidationProvider>
          </div>
          <div class="field col-12 md:col-2">
            <label for="data_nascimento" class="required"
              >Data Nascimento</label
            >
            <ValidationProvider
              name="Data Nascimento"
              rules="required|data_nascimento"
              v-slot="{ errors }"
              mode="lazy"
            >
              <InputMask
                id="data_nascimento"
                v-model.lazy="usuario.data_nascimento"
                mask="99/99/9999"
                :class="{ 'field-invalid': errors[0] }"
              />
              <InlineMessage v-if="errors[0]">{{ errors[0] }}</InlineMessage>
            </ValidationProvider>
          </div>
          <div class="field col-12 md:col-2">
            <label for="Sexo" class="required">Sexo</label>
            <ValidationProvider
              name="Sexo"
              rules="required"
              v-slot="{ errors }"
            >
              <Dropdown
                id="sexo"
                v-model="usuario.sexo"
                :options="dropdownSexo"
                optionLabel="name"
                :class="{ 'field-invalid': errors[0] }"
              />
              <InlineMessage v-if="errors[0]">{{ errors[0] }}</InlineMessage>
            </ValidationProvider>
          </div>
          <div class="p-fieldp-col-12 md:col-3">
            <label for="cpf" class="required">CPF</label>
            <ValidationProvider
              name="CPF"
              rules="required|cpf"
              v-slot="{ errors }"
              mode="lazy"
            >
              <InputMask
                id="cpf"
                v-model="usuario.cpf"
                mask="999.999.999-99"
                :class="{ 'field-invalid': errors[0] }"
              />
              <InlineMessage v-if="errors[0]">{{ errors[0] }}</InlineMessage>
            </ValidationProvider>
          </div>
          <div class="field col-12 md:col-3">
            <label for="rg" class="required">RG</label>
            <ValidationProvider
              name="RG"
              rules="required"
              v-slot="{ errors }"
              mode="lazy"
            >
              <InputNumber
                id="rg"
                v-model="usuario.rg"
                :class="{ 'field-invalid': errors[0] }"
              />
              <InlineMessage v-if="errors[0]">{{ errors[0] }}</InlineMessage>
            </ValidationProvider>
          </div>

          <div class="field col-12 md:col-2">
            <label for="Celular" class="required">Celular</label>
            <ValidationProvider
              name="Celular"
              rules="required"
              v-slot="{ errors }"
              mode="lazy"
            >
              <InputMask
                id="celular"
                v-model="usuario.celular"
                mask="(99) 99999-9999"
                :class="{ 'field-invalid': errors[0] }"
              />
              <InlineMessage v-if="errors[0]">{{ errors[0] }}</InlineMessage>
            </ValidationProvider>
          </div>

          <div class="field col-12 md:col-2">
            <label for="cep" class="required">CEP</label>
            <ValidationProvider
              name="CEP"
              rules="required"
              v-slot="{ errors }"
              mode="lazy"
            >
              <InputMask
                id="cep"
                v-model="usuario.cep"
                mask="99999-999"
                @change="setEndereco()"
                :class="{ 'field-invalid': errors[0] }"
              />
              <InlineMessage v-if="errors[0]">{{ errors[0] }}</InlineMessage>
            </ValidationProvider>
          </div>

          <div class="field col-10">
            <label for="endereco" class="required">Logradouro</label>
            <ValidationProvider
              name="Endereço"
              rules="required"
              v-slot="{ errors }"
              mode="lazy"
            >
              <InputText
                id="endereco"
                type="text"
                v-model="usuario.logradouro"
                :class="{ 'field-invalid': errors[0] }"
              />
              <InlineMessage v-if="errors[0]">{{ errors[0] }}</InlineMessage>
            </ValidationProvider>
          </div>
          <div class="field col-2">
            <label for="numero" class="required">Número</label>
            <ValidationProvider
              name="Numero"
              rules="required"
              v-slot="{ errors }"
              mode="lazy"
            >
              <InputNumber
                id="numero"
                v-model="usuario.numero"
                :class="{ 'field-invalid': errors[0] }"
              />
              <InlineMessage v-if="errors[0]">{{ errors[0] }}</InlineMessage>
            </ValidationProvider>
          </div>
          <div class="field col-5">
            <label for="complemento">Complemento</label>
            <InputText
              id="complemento"
              type="text"
              v-model="usuario.complemento"
            />
          </div>
          <div class="field col-12">
            <label for="bairro" class="required">Bairro</label>
            <ValidationProvider
              name="Bairro"
              rules="required"
              v-slot="{ errors }"
              mode="lazy"
            >
              <InputText
                id="bairro"
                placeholder="Bairro"
                v-model="usuario.bairro"
                :class="{ 'field-invalid': errors[0] }"
              />
              <InlineMessage v-if="errors[0]">{{ errors[0] }}</InlineMessage>
            </ValidationProvider>
          </div>

          <div class="field col-12 md:col-3">
            <label for="estado" class="required">Estado</label>
            <ValidationProvider
              name="Estado"
              rules="required"
              v-slot="{ errors }"
              mode="lazy"
            >
              <Dropdown
                id="estado"
                v-model="estadoSelecionado"
                :options="dropdownEstados"
                @change="setCidades()"
                optionLabel="sigla"
                placeholder="Estado ..."
                :class="{ 'field-invalid': errors[0] }"
              />
              <InlineMessage v-if="errors[0]">{{ errors[0] }}</InlineMessage>
            </ValidationProvider>
          </div>
          <div class="field col-12 md:col-6">
            <label for="cidade" class="required">Cidade</label>
            <ValidationProvider
              name="Cidade"
              rules="required"
              v-slot="{ errors }"
              mode="lazy"
            >
              <Dropdown
                id="cidade"
                v-model="usuario.cidade"
                :options="dropdownCidades"
                placeholder="Cidade ..."
                :class="{ 'field-invalid': errors[0] }"
              />
              <InlineMessage v-if="errors[0]">{{ errors[0] }}</InlineMessage>
            </ValidationProvider>
          </div>

          <div class="field col-12 md:col-6">
            <label for="email" class="required">E-mail</label>
            <ValidationProvider
              name="E-mail"
              rules="required|email"
              vid="email"
              v-slot="{ errors }"
              mode="lazy"
            >
              <InputText
                id="email"
                v-model="usuario.email"
                :class="{ 'field-invalid': errors[0] }"
              />
              <InlineMessage v-if="errors[0]">{{ errors[0] }}</InlineMessage>
            </ValidationProvider>
          </div>

          <div class="field col-12 md:col-6">
            <label for="email" class="required">Redigite o E-mail</label>
            <ValidationProvider
              name="Redigite o E-mail"
              rules="required|confirmed:email"
              v-slot="{ errors }"
              mode="lazy"
            >
              <InputText
                id="confirmeEmail"
                v-model="usuario.confimeEmail"
                type="email"
                :class="{ 'field-invalid': errors[0] }"
              />
              <InlineMessage v-if="errors[0]">{{ errors[0] }}</InlineMessage>
            </ValidationProvider>
          </div>

          <div class="field col-12 md:col-12">
            <Button
              label="Salvar"
              icon="pi pi-check"
              iconPos="left"
              type="submit"
              class="p-button-primary m-2"
              style="width: 120px"
            ></Button>
            <router-link :to="{ name: 'meu.cadastro' }">
              <Button
                label="Cancelar"
                icon="pi pi-arrow-circle-left"
                iconPos="left"
                class="p-button-secondary m-2"
                style="width: 120px"
              ></Button>
            </router-link>
          </div>
        </div>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import http from "@/http";
import { logoutMixin } from "@/mixins";
import { validacaoFormulario } from "@/validacaoFormulario";
import EstatosCidadesService from "../service/EstadosCidadesService";

import axios from "axios";
import CandidatoService from "../service/CandidatoService";
import UsuarioService from "../service/UsuarioService";

export default {
  mixins: [logoutMixin, validacaoFormulario],

  components: {},

  data() {
    return {
      candidatoService: null,
      UsuarioService: null,
      estatosCidadesService: null,
      messages: [],
      confimeEmail: "",
      usuario: {},
      dropdownSexo: [
        { name: "Feminino", code: "F" },
        { name: "Masculino", code: "M" },
      ],
      dropdownEstados: [],
      dropdownCidades: [],
      estadoSelecionado: [],
      emailAtual: "",
    };
  },
  created() {
    this.estatosCidadesService = new EstatosCidadesService();
    this.candidatoService = new CandidatoService();
    this.UsuarioService = new UsuarioService();
  },
  async beforeCreate() {
    /*
		var url = `usuario/${this.$store.state.usuario}`;

		await http.get(url)
				.then(resposta => {
					const usuarioData = resposta.data;
					this.usuario.id = this.$store.state.usuario;
					this.usuario.nome = usuarioData.nome;
                	this.usuario.email = usuarioData.email;
					this.confimeEmail = usuarioData.email;
                	this.usuario.cpf = usuarioData.cpf;
                	this.usuario.rg = parseInt(usuarioData.rg);
            		this.usuario.data_nascimento = this.formatarDataBR(usuarioData.data_nascimento);
					this.usuario.sexo = this.findSexoByCode(usuarioData.sexo);
					this.usuario.idEndereco = usuarioData.enderecos[0].id
                	this.usuario.cep = usuarioData.enderecos[0].cep;
                	this.usuario.logradouro = usuarioData.enderecos[0].logradouro;
                	this.usuario.numero = parseInt( usuarioData.enderecos[0].numero);
                	this.usuario.complemento = usuarioData.enderecos[0].complemento;
                	this.usuario.bairro = usuarioData.enderecos[0].bairro;

					this.usuario.uf = usuarioData.enderecos[0].cidade.estado.uf;
					this.estadoSelecionado = this.getEstadoBySigla(this.usuario.uf);
					this.dropdownCidades = this.estadoSelecionado.cidades;

                	this.usuario.cidade = usuarioData.enderecos[0].cidade.nome;

                	this.usuario.celular = usuarioData.celular.celular;
					this.usuario.senha = usuarioData.senha;
				})
				.catch(erro =>  {
					console.error(erro);
				}) */
  },
  mounted() {
    //this.estatosCidadesService.getEstadosCidades().then(data => this.dropdownEstados = data);
    this.UsuarioService.getUsuarioByIdusuario(this.$store.state.usuario)
        .then((resposta) => {
                    this.usuario = this.candidatoService.parseToUsuarioDTO(resposta);
                    this.emailAtual = this.usuario.email;
                    this.estadoSelecionado = this.usuario.uf;
                    console.log("montou ...", this.usuario.uf, this.emailAtual);

                    this.estatosCidadesService.getEstadosCidades().then((data) => {
                    this.dropdownEstados = data;
                    this.estadoSelecionado = this.getEstadoBySigla(this.usuario.uf);
                    this.setCidades();
                  });
              })
          .catch((erro) => {
                    console.log(erro);
          });
  },
  methods: {
    setEndereco() {
      console.log(this.usuario.cep);
      axios
        .get(`https://viacep.com.br/ws/${this.usuario.cep}/json/`)
        .then((resposta) => {
          console.log("endereco", resposta.data);
          this.usuario.logradouro = resposta.data.logradouro;
          this.usuario.bairro = resposta.data.bairro;
          this.usuario.cidade = resposta.data.localidade;
          this.usuario.uf = resposta.data.uf;
          this.estadoSelecionado = this.getEstadoBySigla(this.usuario.uf);
          this.setCidades();
        })
        .catch((erro) => console.error(erro));
    },

    atualizar() {
      var url = "usuario/" + this.usuario.id;
      let alterouEmail = this.emailAtual != this.usuario.email;
      http.put(url, this.usuario).then(() => {
                  let mensagem = "Cadastro atualizado com sucesso!" + ( alterouEmail ? " Será necessário confirmar o e-mail alterado." : "" );
                  alert(mensagem);
                  this.$router.push({ name: "meu.cadastro" });
                })
        .catch((erro) => {
          if (erro.response) {
            console.log(erro.response);
            // API respondeu
            if (erro.response.data && !erro.response.data.errors) {
              this.messages = [{ severity: "error", content: erro.response.data }];
            } else if (erro.response.data.errors) {
              this.addMessageError(erro.response.data.errors); //vários erros
            } else {
              //apenas a mensagem de erro
              if (erro.response.data.message) {
                this.messages = [{ severity: "error", content: erro.response.data.message }];
              } else {
                this.messages = [{
                                  severity: "error",
                                  content:"Um erro inesperado aconteceu! Tente novamente mais tarde.",
                                },];
              }
            }
          } else {
            //API não respondeu
            this.messages = [
              {
                severity: "error",
                content: "Sistema indisponível! Tente novamente mais tarde.",
              },
            ];
          }
        });
    },

    addMessageError(errors) {
      for (let i = 0; i < errors.length; i++) {
        this.messages.push({
          severity: "error",
          content: `${errors[i].message}`,
        });
      }
    },

    formatarDataBR(dataUS) {
      var dataFormatada = dataUS.substring(0, 11);
      dataFormatada = dataFormatada
        .split("-")
        .reverse()
        .join("/");
      return dataFormatada;
    },

    findSexoByCode(code) {
      let sexo = [];
      for (let i = 0; i < this.dropdownSexo.length; i++) {
        if (this.dropdownSexo[i].code === code) {
          sexo = this.dropdownSexo[i];
          break;
        }
      }
      return sexo;
    },

    getEstadoBySigla(sigla) {
      this.estatosCidadesService = new EstatosCidadesService();
      this.estatosCidadesService
        .getEstadosCidades()
        .then((data) => (this.dropdownEstados = data));

      let estado = [];
      for (let i = 0; i < this.dropdownEstados.length; i++) {
        if (this.dropdownEstados[i].sigla === sigla) {
          estado = this.dropdownEstados[i];
          break;
        }
      }

      return estado;
    },
    setCidades() {
      if (this.estadoSelecionado) {
        this.dropdownCidades = this.estadoSelecionado.cidades;
        this.usuario.uf = this.estadoSelecionado.sigla;
      }
    },
  },
};
</script>
